// extracted by mini-css-extract-plugin
export default {"wrap":"B4g6jrZo3Jc2OUc7ATyJ","details":"_6HvwItsOYInZXYVcDzXn"};